import { forwardRef } from 'react';

import { IconProps } from './icons.types';

import { SvgStyled } from './icons.styles';

export const Cube3DOutlineIcon = forwardRef<SVGSVGElement, IconProps>(function Cube3DOutlineIcon(
  { color = '', height = 12, width = 12, ...props },
  ref,
) {
  return (
    <SvgStyled
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.75702 0.919257L5.75643 0.919577L2.16612 2.8822C2.11096 2.91237 2.06896 2.9775 2.06896 3.06955C2.06896 3.1616 2.11096 3.22673 2.16612 3.2569L5.75643 5.21952L5.75707 5.21987C5.95483 5.32676 6.18308 5.32677 6.38084 5.21988L6.3815 5.21952L9.97182 3.2569C10.0269 3.22671 10.069 3.16155 10.069 3.06955C10.069 2.97755 10.027 2.91243 9.9719 2.88225L6.3815 0.919577L6.38088 0.919245C6.1831 0.812323 5.9548 0.812327 5.75702 0.919257ZM5.36633 0.179587C5.8082 -0.0598623 6.32973 -0.0598623 6.77161 0.179587L6.77293 0.180306L10.3647 2.1437C11.0737 2.53153 11.0738 3.60752 10.3647 3.99535L6.77293 5.95879L6.77161 5.95951C6.32973 6.19896 5.8082 6.19896 5.36633 5.95951L5.365 5.95879L1.77327 3.9954C1.06419 3.60756 1.0641 2.53158 1.77318 2.14375L5.36633 0.179587Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.48713 4.43139C0.807214 4.08672 0 4.5803 0 5.36041V8.56001C0 9.19045 0.354679 9.7645 0.905395 10.0474L0.907114 10.0483L4.24505 11.7432C4.92496 12.0878 5.73242 11.5944 5.73242 10.8143V7.61467C5.73242 6.98423 5.37774 6.41019 4.82703 6.12729L4.82531 6.12641L1.48713 4.43139ZM1.11702 5.18187L4.45375 6.87615C4.73018 7.01851 4.90483 7.30565 4.90483 7.61467V10.8143C4.90483 10.9626 4.75223 11.062 4.61565 10.9929M4.61565 10.9929L1.27943 9.29892L1.27859 9.29849C1.00221 9.15611 0.827587 8.869 0.827587 8.56001V5.36041C0.827587 5.212 0.980404 5.11271 1.11702 5.18187"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5129 4.57656C11.1928 4.23189 12 4.72547 12 5.50558V8.70518C12 9.33562 11.6453 9.90966 11.0946 10.1926L11.0929 10.1934L7.75495 11.8883C7.07504 12.233 6.26758 11.7395 6.26758 10.9594V7.75984C6.26758 7.1294 6.62226 6.55535 7.17297 6.27246L7.17469 6.27157L10.5129 4.57656ZM10.883 5.32704L7.54625 7.02132C7.26982 7.16368 7.09517 7.45082 7.09517 7.75984V10.9594C7.09517 11.1078 7.24777 11.2071 7.38435 11.1381M7.38435 11.1381L10.7206 9.44409L10.7214 9.44366C10.9978 9.30128 11.1724 9.01417 11.1724 8.70518V5.50558C11.1724 5.35716 11.0196 5.25788 10.883 5.32704"
        fill={color || 'currentColor'}
      />
    </SvgStyled>
  );
});
